var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "asset-preview-modal",
        title: "Preview",
        size: "xl",
        centered: "",
        "body-class": "select-folder-preview__body",
        "hide-footer": !_vm.hasDA,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-button",
                {
                  attrs: {
                    variant: "primary",
                    disabled: _vm.selectedAssetIds.length === 0,
                  },
                  on: { click: _vm.confirm },
                },
                [_vm._v("\n      Ok\n    ")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        { staticClass: "select-folder-preview__layout" },
        [
          _vm.item
            ? _c("div", { staticClass: "select-folder-preview__main" }, [
                _c("img", {
                  staticClass: "select-folder-preview__img",
                  attrs: { src: _vm.activeUrl, alt: "" },
                }),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.hasDA
            ? _c(
                "div",
                { staticClass: "select-folder-preview__thumbs" },
                _vm._l(_vm.item.digital_assets, function (asset, index) {
                  return _c(
                    "div",
                    {
                      key: asset.id,
                      staticClass: "select-folder-preview__thumb-wrap",
                    },
                    [
                      _c("input", {
                        staticClass: "select-folder-preview__thumb-check",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.selectedAssetIds.includes(asset.id),
                        },
                        on: {
                          change: function ($event) {
                            $event.stopPropagation()
                            return _vm.toggleAsset(asset)
                          },
                        },
                      }),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "select-folder-preview__thumb",
                        class: { active: _vm.activeIndex === index },
                        attrs: { src: asset.url, alt: asset.name },
                        on: {
                          click: function ($event) {
                            return _vm.selectAsset(index)
                          },
                        },
                      }),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.item
            ? _c("b-alert", { attrs: { show: "", variant: "warning" } }, [
                _vm._v("\n      Preview is not available\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }